import React from 'react';

import styled from 'styled-components';

import { LinkNoDecoration } from 'components/app-header/mobile-header/styled';
import Picture from 'components/picture';
import { useFeatureNavigation } from 'hooks/use-feature-navigation';

const StyledPicture = styled(Picture)`
  width: 24px;
`;

export const HamburgerContainer = styled.div`
  position: fixed;
`;

export const HamburgerButton: React.FC<{ className?: string }> = ({ className }) => {
  const { featureNavigationMobileHeaderButton } = useFeatureNavigation();

  return featureNavigationMobileHeaderButton ? (
    <HamburgerContainer className={className}>
      <LinkNoDecoration to={featureNavigationMobileHeaderButton?.link?.locale ?? ''}>
        <StyledPicture image={featureNavigationMobileHeaderButton?.icon?.locale} alt="icon" />
      </LinkNoDecoration>
    </HamburgerContainer>
  ) : null;
};
